export enum DATA_QA {
  ROOT = 'csv-import-map-step',
  BACK = 'csv-import-map-step__back',
  NEXT = 'csv-import-map-step__next',
  FAMILIAR_NOTICE_CLOSE = 'csv-import-map-step__notice-close',
}
